module.exports = __webpack_public_path__ + "b4847724f67cb9a929e515ff16d239af.pdf";